const PERMISSION_KEY= "core:authz_permission";
const PAGE_URL = {
    AUTHZ_PERMISSION_PAGE: "/admin/core/authz-permission"
}

export {PERMISSION_KEY, PAGE_URL}

